module.exports = __webpack_public_path__ + "img/btn_sm_sign-in.ee53f45.png";